import React from 'react';
import SimpleBar from 'simplebar-react';
import MenuItem from './MenuItem';

interface SidebarProps {
  activeItem: string;
  setActiveItem: (id: string) => void;
  menuItems: { id: string; label: string; path?: string }[];
}

const Sidebar: React.FC<SidebarProps> = ({ activeItem, setActiveItem, menuItems }) => {
  return (
    <div className="card !mb-0 w-10 sm:w-80 lg:w-80 max-w-sm min-w-0 flex-shrink-0">
      <div className="card-body p-4 sm:p-6">
        <div className="flex items-center gap-3 justify-between min-w-0">
          <div className="flex items-center gap-1 min-w-0">
            <h6 className="text-base sm:text-15 grow truncate">Workspaces</h6>
          </div>
        </div>
      </div>
      <SimpleBar className="max-h-[calc(100vh_-_120px)] sm:max-h-[calc(100vh_-_390px)] xl:max-h-[calc(100vh_-_300px)]">
        <ul className="flex flex-col gap-1 px-2 sm:px-0">
          {menuItems.map((item) => (
            <MenuItem
              key={item.id}
              item={item}
              activeItem={activeItem}
              setActiveItem={setActiveItem}
            />
          ))}
        </ul>
      </SimpleBar>
    </div>
  );
};

export default Sidebar;